import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`pargProgressPanel ofs pad10 posFi noscroll`)
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "appointmentContent"
}
const _hoisted_5 = { class: "w100 centered mt20" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fs20 fw600" }, "進捗状況", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = {
  class: /*#__PURE__*/_normalizeClass(`w100 fr posRe `)
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_12 = { class: "fs12 fw600" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "fl" }, "調整開始:", -1)
const _hoisted_14 = { class: "fl" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { class: "fs12 fw600" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "fl" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "mt20 mb20 pad12 llgreyBg rad6 hoverLgreyBg"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600" }, "🤖 確定時、AIが対応予定", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  class: /*#__PURE__*/_normalizeClass(`headerContent lskyblueBg pad10 pointer rad8 mt10`)
}
const _hoisted_28 = { class: "fs12 fw600 fl dblue mt5 mr10" }
const _hoisted_29 = {
  key: 0,
  class: "fs12 fw600 mr5 fl"
}
const _hoisted_30 = { class: "arial fs20" }
const _hoisted_31 = {
  key: 1,
  class: "label gradBlueBg fl mt7"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = { class: "fl ml10" }
const _hoisted_35 = { class: "fs12 fw600" }
const _hoisted_36 = { class: "fs13 fw600 mt3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = {
  key: 0,
  class: "fr"
}
const _hoisted_39 = { class: "mt3 fl mr3" }
const _hoisted_40 = ["src"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_42 = { class: "fl ml10" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "fs12 fw600" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppointmentCardViewSmall = _resolveComponent("AppointmentCardViewSmall")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
        width: "36",
        height: "36",
        class: "fr pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePanel && _ctx.closePanel(...args)))
      }, null, 8, _hoisted_2),
      _hoisted_3,
      (_ctx.panelType == `parg`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _createElementVNode("div", null, _toDisplayString(_ctx.parg.public_id), 1)
              ]),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_AppointmentCardViewSmall, {
                  appo: _ctx.parg.current_appointment,
                  title: _ctx.parg.title,
                  locationName: _ctx.parg.location_name,
                  startTime: _ctx.parg.start_time,
                  editEditableContent: _ctx.editEditableContent
                }, null, 8, ["appo", "title", "locationName", "startTime", "editEditableContent"]),
                _hoisted_10,
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: "fl pointer centered circle_button blueAround fs12 rad8 fw600 pad6",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickRemindForAll && _ctx.clickRemindForAll(...args)))
                  }, " 全体リマインド ")
                ]),
                _hoisted_11,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.Util.getTimeFullFormatFromSeconds(_ctx.parg.created_at)), 1),
                    _hoisted_15
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (!['fixed', 'canceled'].includes(_ctx.parg.current_block_type))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (_ctx.parg.last_block_updated_at > _ctx.DateTime.now().minus({ days: 1 }).toSeconds())
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.$getAssetImageUrl(`/assets/icons/status_play.png`),
                                width: "12",
                                height: "14",
                                class: "fl ml2"
                              }, null, 8, _hoisted_18))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: _ctx.$getAssetImageUrl(`/assets/icons/status_suspend.png`),
                                width: "12",
                                height: "14",
                                class: "fl mr1 ml2"
                              }, null, 8, _hoisted_19))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.ParentRoomGroup.blockTypeText(_ctx.parg.current_block_type, true)), 1),
                    _hoisted_21
                  ]),
                  _hoisted_22,
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                                    `block_1`,
                                    `block_2`,
                                    `block_3`,
                                    `block_4`,
                                    `block_5`,
                                    `use_ai_fix`,
                                    `fixer`,
                                    `approval`,
                                ], (_block, blockindex) => {
                    return _createElementVNode("div", { key: blockindex }, [
                      (_block == `use_ai_fix` && _ctx.parg.use_ai_fix)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                        : _createCommentVNode("", true),
                      (_ctx.parg.step_rooms_dic[_block])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.ParentRoomGroup.blockTypeText(_block, false)), 1),
                              (![`fixer`, `approval`].includes(_block))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.suggestedCount(_block)), 1),
                                    _createTextVNode("人提案済み ")
                                  ]))
                                : _createCommentVNode("", true),
                              (_block == _ctx.parg.current_block_type)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, "進行中"))
                                : _createCommentVNode("", true),
                              _hoisted_32
                            ]),
                            _hoisted_33,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parg.step_rooms_dic[_block], (_mem, memindex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: memindex,
                                class: "mt10 pad10 hoverLgreyBg rad8"
                              }, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("div", _hoisted_35, _toDisplayString(_mem.company_name), 1),
                                  _createElementVNode("div", _hoisted_36, _toDisplayString(_mem.name), 1),
                                  _hoisted_37
                                ]),
                                (_mem.line_parent_room.last_suggested_at)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                      _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.Util.getTimeFullFormatFromSeconds(_mem.line_parent_room.last_suggested_at)), 1),
                                      _withDirectives(_createElementVNode("img", {
                                        src: _ctx.$getAssetImageUrl(`/assets/icons/vote_r.png`),
                                        width: "20",
                                        height: "20",
                                        class: "fl pointer ml5 mt1"
                                      }, null, 8, _hoisted_40), [
                                        [_directive_tooltip, 
                                                    `提案済み(${_mem.line_parent_room.optional_schedules_count}):\n${(
                                                        _mem.line_parent_room.optional_schedules || []
                                                    )
                                                        .map(o => o.jp_format)
                                                        .join(`\n`)}`
                                                ]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _hoisted_41,
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("div", {
                                    class: "fl pointer centered underline fs12 fw600 mr10 mt10",
                                    onClick: ($event: any) => (_ctx.showUrl(_mem))
                                  }, " 調整URLをコピー ", 8, _hoisted_43),
                                  _createElementVNode("div", {
                                    class: "fl pointer centered circle_button blueAround fs12 rad8 fw600 pad6 mr10",
                                    onClick: ($event: any) => (_ctx.clickRemind(_mem))
                                  }, " リマインドする ", 8, _hoisted_44),
                                  (_mem.line_parent_room.optional_schedules)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "fl pointer centered underline fs12 fw600 mr10 mt10",
                                        onClick: ($event: any) => (_ctx.showOptionalSchedules(_mem))
                                      }, " 提案日程 ", 8, _hoisted_45))
                                    : _createCommentVNode("", true),
                                  _hoisted_46,
                                  (_mem.line_parent_room.optional_schedules)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                        (_ctx.isShowOptionalSchedules(_mem))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                              _createElementVNode("div", _hoisted_49, " 提案済み(" + _toDisplayString(_mem.line_parent_room.optional_schedules_count) + "件) ", 1),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_mem.line_parent_room.optional_schedules, (_opt, optindex) => {
                                                return (_openBlock(), _createElementBlock("div", { key: optindex }, _toDisplayString(_opt.jp_format), 1))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _hoisted_50
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  }), 64))
                ])
              ])
            ]),
            _hoisted_51
          ]))
        : _createCommentVNode("", true),
      _hoisted_52
    ])
  ]))
}